import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { Suspense } from 'react';

import { AnalyticsError } from '../../../../components/error/analyticsError';
import { AnalyticsLoading } from '../../../../components/loading/analyticsLoading';

import { IntelligenceRemote } from './components/remote/intelligenceRemote';

export const IntelligenceRemoteView = (): JSX.Element => {
  return (
    <ErrorBoundary fallback={<AnalyticsError />}>
      <Suspense fallback={<AnalyticsLoading />}>
        <IntelligenceRemote />
      </Suspense>
    </ErrorBoundary>
  );
};
